export default "__VITE_ASSET__C$iQXpuU__"